import { silentClient } from '@api/client';
import type { StreamingMetrics, StreamingStatsData } from '@api/types';

export async function sendStreamingMetrics(stats: StreamingMetrics): Promise<{ ok: boolean }> {
    const response = await silentClient.POST('/streaming/metrics', {
        body: stats,
    });
    return {
        ok: response.response.ok,
    };
}

export async function sendStreamingStatistics(stats: StreamingStatsData): Promise<{ ok: boolean }> {
    const response = await silentClient.POST('/streaming/statistics', {
        body: stats,
    });
    return {
        ok: response.response.ok,
    };
}